export const titleTemplate = {
  '_template': 'title',
  'title': {
    es: 'This Week Highlights',
    en: 'This Week Highlights'
  },
  'text': {
    'fontSize': {
      'xl': 48,
      'xs': 36
    },
    'align': {
      'xl': 'center'
    },
    'bold': {
      'xl': 'bold'
    },
    'lineHeight': {
      'xl': 1.2,
      'xs': 1.2
    }
  },
  'box': {
    'size': {
      'maxWidth': {
        'xl': 800
      }
    }
  }
};
